import { render, staticRenderFns } from "./StudentGraduationsSlidebar.vue?vue&type=template&id=292b09fe"
import script from "./StudentGraduationsSlidebar.vue?vue&type=script&lang=js"
export * from "./StudentGraduationsSlidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports